var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_tools",
    transform: "translate(2.744 2.834)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 28,
    height: 28,
    transform: "translate(-2.744 -2.834)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M26.412,11.37l-.146-.709a1.039,1.039,0,0,0-1.519-.7L20.3,12.414a6.114,6.114,0,0,1-1.034-1.563,5,5,0,0,1-.527-1.8l4.627-2.573a1.039,1.039,0,0,0,.009-1.81,8.092,8.092,0,0,0-3.7-1.067,8.872,8.872,0,0,0-5.931,2.121c-.021.021-.041.043-.06.065C11.919,7.885,12,10.882,12.12,12.115L3.784,20.448A3.4,3.4,0,0,0,2.8,22.972a3.813,3.813,0,0,0,1.135,2.6l.154.154a3.8,3.8,0,0,0,2.533,1.135h.023l.146,0a3.344,3.344,0,0,0,2.419-.989l8.248-8.248a10.439,10.439,0,0,0,2.519.392,6.118,6.118,0,0,0,2.977-.723c1.757-.967,2.921-2.821,3.459-5.511A1.043,1.043,0,0,0,26.412,11.37Zm-4.457,4.1a4.06,4.06,0,0,1-1.97.466,9.417,9.417,0,0,1-2.483-.47,1.038,1.038,0,0,0-1.073.248L7.741,24.4a1.281,1.281,0,0,1-.931.38l-.114,0a1.759,1.759,0,0,1-1.137-.527L5.4,24.1a1.744,1.744,0,0,1-.526-1.185,1.341,1.341,0,0,1,.376-1l8.7-8.693a1.039,1.039,0,0,0,.288-.918c-.006-.032-.534-3.266,1-5.142a6.965,6.965,0,0,1,4.431-1.481,3.976,3.976,0,0,1,.727.073L17.219,7.523a1.039,1.039,0,0,0-.514.708A5.933,5.933,0,0,0,17.4,11.76a5.914,5.914,0,0,0,2.332,2.832,1.04,1.04,0,0,0,.963-.021l3.315-1.83A4.721,4.721,0,0,1,21.954,15.473Z",
    transform: "translate(-2.8 -3.604)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTools);
export default __webpack_public_path__ + "static/media/ico-tools.15c7aedc5d2e95bf7bdf7cb28c819519.svg";
export { ForwardRef as ReactComponent };